module.exports = __webpack_public_path__ + "img/yt.f7379ff1.svg";